<template>
	<div style="transition: 0.3s;">
		<div id="cards" :style="cards_style">
			<CardBack
				class="card"
				v-for="(_, index) in amount_cards"
				v-bind:key="index"
				:style="card_style(index)"
			/>
		</div>
		<div :style="player_box_style" @click="$emit('click')" ref="player_box">
			<div id="player_box_inner">
				<div id="player_name">
					<fitty :options="fitty_options">
						<template v-slot:content>
							<span style="width: 100%;">{{ player_name }}</span>
						</template>
					</fitty>
				</div>
				<div id="card_count">{{ amount_cards }}</div>
			</div>
		</div>
	</div>
</template>

<style scoped>
#player_box_inner {
	position: absolute;
	left: 15%;
	top: 15%;
	width: 70%;
	height: 70%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
}

#player_name, #card_count {
	color: #FFFFFF;
	margin: 5px;
	text-align: center;
	overflow: hidden;
	display: inline-block;
}
#player_name {
	width: 100%;
	font-weight: bold;
	overflow-wrap: anywhere;
}
</style>

<script lang="ts">
import Vue from "vue";

import CardBack from "@/assets/card_back.svg";

import { hsluvToHex } from "hsluv";
import XXH from "xxhashjs";

export default Vue.extend({
	components: {
		CardBack
	},
	props: {
		angle: Number,
		player_name: String,
		amount_cards: Number,
		player_index: Number,
		selecting: Boolean
	},
	data() {
		return {
			cards_size_ratio: 0.22,
			cards_width_ratio: 4.41,
			window_size: Math.min(window.innerWidth, window.innerHeight * 1.4),
			hover: false,
			fitty_options: {
				minSize: 8,
				maxSize: 25,
				observeMutations: {
					subtree: true,
					childList: true,
					characterData: true,
					attributes: true,
					attributeFilter: [
						"width", "height"
					]
				}
			}
		}
	},
	mounted() {
		window.addEventListener('resize', () => {
			this.window_size = Math.min(window.innerWidth, window.innerHeight * 1.4);
		});
		this.$refs.player_box.onmouseover = () => this.hover = true;
		this.$refs.player_box.onmouseout = () => this.hover = false;
	},
	methods: {
		hue(s) {
			let hash = XXH.h32(s.toLowerCase(), 0x5240);
			return (180 + 30 + hash % 300) % 360;
		},
		card_style(index) {
			let card_size_width_ratio = 0.63;
			let gap = 0.03;
			let card_width = this.box_size * this.cards_size_ratio * card_size_width_ratio;
			let s = card_size_width_ratio / this.cards_width_ratio;
			let n = this.amount_cards;
			let width = n * s + (n - 1) * gap;
			var p = 0.0;
			if (width <= 1.0) {
				p = 0.5 - 0.5 * (n * s + (n - 1) * gap) + index * (s + gap);
			} else {
				p = (1.0 - s) * (index / (n - 1));
			}

			return {
				position: "absolute",
				height: this.box_size * this.cards_size_ratio + "px",
				width: card_width + "px",
				left: p * 100 + "%",
				"box-sizing": "border-box",
				transition: "0.3s",
			}
		}
	},
	computed: {
		box_size() {
			let size = Math.min(Math.max(this.window_size / 7.0, 120.0), 160.0);
			if (this.$store.state.mobile) return size / 1.5;
			return size;
		},
		player_box_style() {
			let box_radius = this.box_size / 2.0;
			let playing = this.$store.state.game_data.cur_player == this.player_index;
			let hue = this.hue(this.player_name);
			let col = hsluvToHex([hue, 80, 50]);
			return {
				position: "absolute",
				"background-color": col,
				height: this.box_size + "px",
				width: this.box_size + "px",
				"border-radius": "50%",
				transform:
					"translate(-" + box_radius + "px, -" + box_radius + "px)" +
					(this.selecting ? (this.hover ? "scale(1.2) " : "scale(1.1)") : ""),
				cursor: this.selecting ? "pointer" : "auto",
				display: "flex",
				"flex-direction": "column",
				"justify-content": "center",
				"align-items": "center",
				border: this.selecting ? "4px solid #DDDDDD" : "4px solid #000000",
				"box-shadow":
					"inset 0 0 24px " + (playing ? "#00FFFF" : "#000000") +
					(this.selecting ? ", 0 0 24px #FFAA00" : ""),
				"box-sizing": "border-box",
				transition: "0.3s"
			};
		},
		cards_style() {
			let box_radius = this.box_size / 2.0;
			return {
				position: "absolute",
				height: this.box_size * this.cards_size_ratio + "px",
				width: this.box_size * this.cards_size_ratio * this.cards_width_ratio + "px",
				"transform-origin": "50%" + -(box_radius + 10) + "px",
				transform:
					"translate(-" + box_radius + "px, -" + box_radius + "px)" +
					"translate(" +
					-(50.0 - 50.0 / (this.cards_width_ratio * this.cards_size_ratio)) + "%," +
					(this.box_size + 10) + "px" +
					")" +
					"rotate(" + this.angle + "rad)",
			}
		}
	}
})
</script>
